import { duration } from "moment-timezone";

export class FpsFunctions {
    public static GetFpsString(fps: number): string {
        if (fps < 1) {
            const sec = 1.0 / fps;
            if (sec < 40) {
                return `${sec.toFixed(0)} s`;
            }

            const time = duration(sec, "second");
            return time.humanize();
        }

        return `${fps} fps`;
    }
}
